"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentedGroup = void 0;
const react_1 = __importStar(require("react"));
const SegmentedGroup_styles_1 = require("./SegmentedGroup.styles");
const isSelected = (groupValue, childValue) => {
    if (groupValue == null || childValue == null)
        return false;
    if (Array.isArray(groupValue)) {
        return groupValue.findIndex((gv) => gv === childValue) >= 0;
    }
    return groupValue === childValue;
};
const handleSelect = (onClick, groupValue) => (event, childValue) => {
    if (childValue == null) {
        onClick(event, groupValue);
    }
    else {
        onClick(event, childValue);
    }
};
const handleSelectMultiple = (onClick, groupValue) => (event, childValue) => {
    if (childValue == null) {
        onClick(event, groupValue);
    }
    else {
        const valIndex = groupValue.findIndex((gv) => gv === childValue);
        const newGroupValue = valIndex >= 0
            ? [...groupValue.slice(0, valIndex), ...groupValue.slice(valIndex + 1)]
            : [...groupValue, childValue];
        onClick(event, newGroupValue);
    }
};
exports.SegmentedGroup = (0, react_1.forwardRef)((_a, ref) => {
    var { type, children, disabled = false, variant = 'default', value, onClick } = _a, restProps = __rest(_a, ["type", "children", "disabled", "variant", "value", "onClick"]);
    return (react_1.default.createElement(SegmentedGroup_styles_1.SegmentGroup, Object.assign({ ref: ref, variant: variant, role: "group" }, restProps), react_1.default.Children.map(children, (child) => {
        if (!react_1.default.isValidElement(child))
            return null;
        const { selected, value: childValue } = child.props;
        return react_1.default.cloneElement(child, {
            selected: selected == null ? isSelected(value, childValue) : selected,
            onClick: type === 'multiple'
                ? handleSelectMultiple(onClick, value)
                : handleSelect(onClick, value),
            disabled
        });
    })));
});
exports.SegmentedGroup.displayName = 'SegmentedGroup';
//# sourceMappingURL=SegmentedGroup.js.map